export default {
    name: 'zh-cn',
    component: {
        confirmPayment: {
            message: '请确认您的支付结果…',
            closeBtnText: '关闭',
            endBtnText: '支付完成'
        }
    },
    request: {
        loadingText: '加载中...',
        err500: '服务器异常，请稍后重试'
    },
    page: {
        activeCode: {
            activeTitle: '激活游戏',
            codePlaceholder: '请输入游戏激活码',
            activeBtnText: '立即激活',
            buttonContent: '激活说明',
            urlContent: '外部链接',
            activeSuccessMsg: '激活成功'
        },
        activeInstructions: {
            introTitle: '激活说明',
            closeBtnText: '关闭'
        },
        cashier: {
            title: '订单支付',
            goods: '商品名称：',
            money: '订单金额：',
            wayName: '支付',
            payBtnText: '立即支付',
            unit: '¥',
            loadingText: '支付中...'
        }
    }
}
